<template>
  <div>
    <ImportSteps :titles="['Upload Planilha', 'Mapear colunas', 'Resultado']" :active="active" />
    <transition :name="'import-slide-' + direction" mode="out-in">
      <div :key="active">

        <UploadSheet :fileData="fileData" v-on:upload="fileUpload" v-if="active === 0" v-on:next="next" :sample="true" />

        <MappingColumn :fileData="fileData" :columnData="columnData" :customer="customer" :userType="userType"
          v-on:validate="columnValidate" v-if="active === 1" v-on:next="next" v-on:back="back" />

        <ResultingPrespostAudit :file="file" :customer="customer" :records="fileData" v-if="active === 2" v-on:reset="reset" />

      </div>
    </transition>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import ImportSteps from './ImportSteps.vue';
import MappingColumn from './prepost/MappingColumn.vue';
import UploadSheet from './prepost/UploadSheet.vue';
import ResultingPrespostAudit from "./prepost/ResultingPrespostAudit.vue";

export default {
  name: "ImportPrepost",
  props: ["state"],
  components: {
    ImportSteps,
    UploadSheet,
    MappingColumn,
    ResultingPrespostAudit
},
  props: ["type"],
  methods: {
    fileUpload(data, file) {
      const vm = this;
      if (data.length > 3000) {
        return this.$message({
          type: "error",
          message: "Limite da importação é 3000 linhas por arquivo",
        });
      }
      vm.fileOrigin = data;
      vm.fileData = data;
    },
    columnValidate(data, customer, fileData) {
      const vm = this;
      vm.columnData = data;
      vm.customer = customer;
      vm.fileData = fileData;
    },
    reset() {
      const vm = this;
      vm.columnData = [];
      if (vm.me.type === '2' || vm.me.type === '5') {
        vm.customer = vm.me.customers ? vm.me.customers.id : '';
      } else {
        vm.customer = "";
      }
      vm.fileData = [];
      vm.resultingData = [];
      vm.direction = 'back';
      vm.active = 0;
    },
    finish() {
      const vm = this;
      vm.active = 2;
    },
    next() {
      const vm = this;
      if (vm.active === 0 && vm.fileData.length === 0) {
        return this.$message({
          type: "error",
          message: "Planilha está sem postagem",
        });
      }
      vm.direction = 'forward';
      vm.active++;
    },
    back() {
      const vm = this;
      vm.direction = 'back';
      vm.active--;
      if (vm.active == 1) {
        vm.fileData = vm.fileOrigin;
      }
    },
    downloadSample() {
      window.open("/xpost/prepost-template.csv");
    },
  },
  data() {
    return {
      columnData: [],
      fileData: [],
      fileOrigin: [],
      resultingData: [],
      quotationData: [],
      customer: '',
      userType: '2',
      me: {},
      active: 0,
      direction: 'forward',
      file: '',
    };
  },
  async created() {
    const vm = this;
    vm.me = await UserService.me().catch((error) => {
      this.$message({
        type: "error",
        message: error,
      });
    });
    vm.userType = vm.me.type;
    if (vm.me.type === '2' || vm.me.type === '5') {
      vm.customer = vm.me.customers ? vm.me.customers.id : '';
    }
  },
};
</script>

